import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Integration } from '../objects/Integration';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  public integration: Observable<Integration>;
  private integrationSubject: BehaviorSubject<Integration>;

  constructor() {
    this.integrationSubject = new BehaviorSubject(new Integration());
    this.integration = this.integrationSubject.asObservable();
  }

  public getState(): Integration {
    return this.integrationSubject.getValue();
  }

  public setState(integration: Integration): void {
    this.integrationSubject.next(integration);
  }
}
